export default {"src":"/_next/static/media/placeholderImage.c1b77407.svg","height":40,"width":40};